// extracted by mini-css-extract-plugin
module.exports = {"Dropzone":"Dropzone_Dropzone__3dhUZ","Highlight":"Dropzone_Highlight__28VZ9","Icon":"Dropzone_Icon__U3MGh","FileInput":"Dropzone_FileInput__1HK6P"};